import { Component, OnDestroy, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IrisLogoService } from '@iris/common/services/logo.service';
import { Subject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import { ImprintInfoModalComponent } from './imprint-info-modal/imprint-info-modal.component';
import { ToastService } from '@ngx-strakit/cdk/controls/toast';
import { TranslateService } from '@ngx-translate/core';
import { IrisMsalService } from '@iris/modules/msal/msal.service';

const COOKIE_AGREEMENT_KEY = 'cookieAgreement';

@Component({
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  standalone: false,
})
export class AuthComponent implements OnDestroy {
  private readonly logoService = inject(IrisLogoService);
  private readonly dialog = inject(MatDialog);
  private readonly toastService = inject(ToastService);
  private readonly translateService = inject(TranslateService);
  private readonly irisMsalService = inject(IrisMsalService);

  private readonly destroySubject = new Subject<void>();

  imageUrl$ = this.logoService.imageUrl$;

  isAgreementVisible = !localStorage.getItem(COOKIE_AGREEMENT_KEY);

  constructor() {
    const logoService = this.logoService;

    logoService.loadBrands().pipe(
      switchMap(() => logoService.activeBrand$),
      tap((activeBrand) => logoService.appendWebIcons(activeBrand.brand)),
      takeUntil(this.destroySubject),
    ).subscribe();
  }

  showInfoModal(): void {
    this.dialog.open<ImprintInfoModalComponent>(ImprintInfoModalComponent);
  }

  acceptCookies(): void {
    if (this.isAgreementVisible) {
      localStorage.setItem(COOKIE_AGREEMENT_KEY, 'yes');
      this.isAgreementVisible = false;
    }
  }

  clearMsalCache() {
    this.irisMsalService.clearCache();
    this.toastService.success({ message: this.translateService.instant('message.Cache.Success') });
    setTimeout(() => window.location.reload(), 1000);
  }

  ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }
}
